var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldAddonDropdown, InputText, Spinner, Tooltip, } from '@dixa/lib-shared-habla';
import { unwrapResult } from '@reduxjs/toolkit';
import { boundMethod } from 'autobind-decorator';
import { config } from 'lib-shared-backend-config';
import filter from 'lodash/filter';
import find from 'lodash/find';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import { Sentry } from 'app/utils/sentry';
import { containsNumber, getPhoneNumberDetails, isNumberValid, numberFormatterE164, } from 'app/utils/telephonyHelpers';
import { Autocomplete } from 'components/shared/util/autocomplete';
import { CountryCodeDropdownItem } from '../CountryCodeDropdownItem';
import { CountryCodeSelected } from '../CountryCodeSelected';
import ListUsers from '../ListUsers';
import styles from './searchUser.module.scss';
import '../../styles/search-users-to-call.less';
import { spreadPhoneUsers } from './utils/spreadPhoneUsers';
export class SearchUser extends React.Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();
        this.state = {
            highlightedIndex: null,
            phoneUsers: [],
            countryISOSelected: '',
            countryCodeSelected: '',
            countryDropdownOpen: false,
            loading: true,
        };
        this.autocomplete = new Autocomplete(this._requestGetUsers);
    }
    componentDidMount() {
        this.updateUserCountryCodeDetails();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        // If `users` has changed we want to reset `highlightedIndex`
        // since it probably no longer refers to a relevant item.
        //
        // The entries in `users` may have been changed even though the
        // object reference remains the same, double check by seeing
        // if `highlightedIndex` points to an existing item.
        let phoneUsers = [];
        let nextPhoneUsers = [];
        if (nextProps.searchValue.length > 0) {
            if (nextProps.searchValue !== this.props.searchValue) {
                this.autocomplete.search(nextProps.searchValue);
            }
            if (this.props.users.length > 0) {
                phoneUsers = this.props.users.filter((user) => typeof user.phone_number === 'string' && user.phone_number !== '');
            }
            if (nextProps.users.length > 0) {
                nextPhoneUsers = nextProps.users.filter((user) => typeof user.phone_number === 'string' && user.phone_number !== '');
            }
            if ((phoneUsers === null || phoneUsers === void 0 ? void 0 : phoneUsers.length) !== (nextPhoneUsers === null || nextPhoneUsers === void 0 ? void 0 : nextPhoneUsers.length) ||
                (this.state.highlightedIndex &&
                    this.state.highlightedIndex >= nextPhoneUsers.length)) {
                this.setState({
                    highlightedIndex: null,
                    phoneUsers: spreadPhoneUsers(nextPhoneUsers),
                });
            }
            else {
                this.setState({
                    phoneUsers: spreadPhoneUsers(nextPhoneUsers),
                });
            }
        }
        else {
            this.setState({
                phoneUsers: spreadPhoneUsers(phoneUsers),
            });
        }
    }
    componentDidUpdate(prevProps) {
        var _a, _b;
        if (!this.state.countryDropdownOpen && !this.props.isOwnNumbersViewOpen) {
            this.focusInput();
        }
        if (((_a = this.props.selectedFromNumber) === null || _a === void 0 ? void 0 : _a.e164_format) !==
            ((_b = prevProps.selectedFromNumber) === null || _b === void 0 ? void 0 : _b.e164_format)) {
            this.updateUserCountryCodeDetails();
        }
    }
    updateUserCountryCodeDetails() {
        var _a;
        const selectedFromNumber = (_a = this.props.selectedFromNumber) === null || _a === void 0 ? void 0 : _a.e164_format;
        if (isNumberValid({ phoneNumber: selectedFromNumber })) {
            const phone = getPhoneNumberDetails(selectedFromNumber);
            this.setState({
                countryISOSelected: phone.countryISO,
                countryCodeSelected: phone.countryCode,
                loading: false,
            });
        }
    }
    focusInput() {
        var _a;
        (_a = this.input.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    setSearchValue(inputValue) {
        this.props.setSearchUserValue(`${this.state.countryCodeSelected}${inputValue}`);
    }
    handlePhoneNumberInput(inputValue) {
        const { countries } = this.props;
        const inputtedCode = inputValue.substring(1);
        const country = countries.items.find((country) => country.phone === inputtedCode);
        if (country) {
            // US has the same country code as Canada and 23 other countries
            // that are closely connected to the US, we want to show US by
            // default this is the only exception in the logic
            if (country.phone === '1') {
                this.setState({
                    countryCodeSelected: '+1',
                    countryISOSelected: 'us',
                });
            }
            else {
                this.setState({
                    countryCodeSelected: `+${country.phone}`,
                    countryISOSelected: country.iso.toLowerCase(),
                });
            }
        }
        this.setSearchValue(inputValue);
    }
    handleCopyPastePhoneNumber(inputValue) {
        const phone = getPhoneNumberDetails(inputValue);
        this.setState({
            countryCodeSelected: phone.countryCode,
            countryISOSelected: phone.countryISO,
        }, () => {
            this.props.setSearchUserValue(`${this.state.countryCodeSelected}${phone.nationalNumber}`);
        });
    }
    onChangeInput(e) {
        if (!e)
            return;
        // Prevent multiple spaces
        const inputValue = e.target.value.replace(/\s\s+/g, ' ');
        if (containsNumber(inputValue)) {
            if (isNumberValid({ phoneNumber: inputValue }) &&
                inputValue.startsWith('+')) {
                this.handleCopyPastePhoneNumber(inputValue);
            }
            else if (inputValue.startsWith('+')) {
                this.handlePhoneNumberInput(inputValue);
            }
            else {
                this.setSearchValue(inputValue);
            }
        }
        else {
            this.props.setSearchUserValue(inputValue);
        }
    }
    _requestGetUsers(searchValue) {
        let searchQuery = searchValue.trim();
        if (searchQuery.length !== 0) {
            if (searchQuery.startsWith('+')) {
                const queryWithoutCode = searchQuery.replace(this.state.countryCodeSelected, '');
                // If the provided query is a number, we'll also include the raw number without the country code,
                // which will ensure that we also get results where the user display name contains the number
                if (queryWithoutCode) {
                    // In order to match both the display name and the phone number,
                    // we separate the queries by space, and the number without code must be first
                    searchQuery = `${queryWithoutCode} ${searchQuery}`;
                }
            }
            this.props.getUsersByQuery({ search: searchQuery });
        }
        else {
            // We reset the phoneUsers result if there is no searchValue.
            this.setState({ phoneUsers: [] });
        }
    }
    searchInputKeyDown(e) {
        if (!e)
            return;
        //closing Collapsible component
        const phone_number = this.props.searchValue;
        this.props.toggleOwnNumbersView(false);
        if (e.which === 8 &&
            this.props.searchValue.trim() === '' &&
            this.props.fromNumberCountryCode !== null) {
            // Backspace key pressed.
            const fromNumberCountryCode = null;
            this.props.setFromNumberCountryCode(fromNumberCountryCode); // Reset fromNumberCountryCode.
            // Enter key pressed.
        }
        else if (e.which === 13 && this.props.canMakeOutBoundCall === true) {
            let user;
            // There is nothing selected on highlightedIndex, we try to find the user by the phone_number.
            if (this.state.highlightedIndex === null &&
                isNumberValid({ phoneNumber: phone_number }) === true) {
                const phoneNumberE164 = numberFormatterE164({
                    phoneNumber: phone_number,
                });
                user = find(this.state.phoneUsers, { phone_number: phoneNumberE164 });
            }
            else if (this.state.highlightedIndex === null &&
                isNumberValid({
                    phoneNumber: this.props.fromNumberCountryCode + phone_number,
                }) === true) {
                const phoneNumberE164 = numberFormatterE164({
                    phoneNumber: this.props.fromNumberCountryCode + phone_number,
                });
                user = find(this.state.phoneUsers, { phone_number: phoneNumberE164 });
            }
            else if (this.state.highlightedIndex === null &&
                isNumberValid({
                    phoneNumber: `+${this.props.fromNumberCountryCode}${phone_number}`,
                }) === true) {
                const phoneNumberE164 = numberFormatterE164({
                    phoneNumber: `+${this.props.fromNumberCountryCode}${phone_number}`,
                });
                user = find(this.state.phoneUsers, { phone_number: phoneNumberE164 });
            }
            else if (this.state.highlightedIndex === null &&
                this.state.phoneUsers.length === 1) {
                user = this.state.phoneUsers[0];
            }
            else if (this.state.highlightedIndex !== null) {
                user = this.state.phoneUsers[this.state.highlightedIndex];
            }
            if (user !== undefined) {
                // The user already exists try to make the call.
                this.makeCallClickHandler(user);
            }
            else if (isNumberValid({ phoneNumber: phone_number })) {
                // Try with full phone_number.
                // The user does not exists.
                // We make a new user and call it afterwords.
                user = {
                    id: 'newUser',
                    avatar_url: null,
                    icon: 'phone',
                    is_admin: false,
                    is_agent: false,
                    email: null,
                    phone_number: numberFormatterE164({ phoneNumber: phone_number }),
                    name: null,
                    roles: [],
                };
                this.makeCallClickHandler(user);
            }
            else if (isNumberValid({
                phoneNumber: this.props.fromNumberCountryCode + phone_number,
            })) {
                // Try with full phone_number with a countrycode prefix .
                user = {
                    id: 'newUser',
                    avatar_url: null,
                    icon: 'phone',
                    is_admin: false,
                    is_agent: false,
                    email: null,
                    phone_number: numberFormatterE164({
                        phoneNumber: this.props.fromNumberCountryCode + phone_number,
                    }),
                    name: null,
                    roles: [],
                };
                this.makeCallClickHandler(user);
            }
            else if (isNumberValid({
                phoneNumber: `+${this.props.fromNumberCountryCode}${phone_number}`,
            })) {
                // Try with full phone_number with + sign and countrycode as prefix.
                user = {
                    id: 'newUser',
                    avatar_url: null,
                    icon: 'phone',
                    is_admin: false,
                    is_agent: false,
                    email: null,
                    phone_number: numberFormatterE164({
                        phoneNumber: `+${this.props.fromNumberCountryCode}${phone_number}`,
                    }),
                    name: null,
                    roles: [],
                };
                this.makeCallClickHandler(user);
            }
            else {
                console.error('Does not have a valid phone number', phone_number);
            }
        }
        else if (e.which === 40) {
            // Arrow down.
            e.preventDefault();
            try {
                const numberOfOptions = this.state.phoneUsers.length;
                if (!numberOfOptions) {
                    return;
                }
                const highlightedIndex = this.state.highlightedIndex;
                const index = highlightedIndex === null || highlightedIndex === numberOfOptions - 1
                    ? 0
                    : highlightedIndex + 1;
                this.setState({ highlightedIndex: index });
            }
            catch (exception) { }
        }
        else if (e.which === 38) {
            // Arrow up.
            e.preventDefault();
            try {
                const numberOfOptions = this.state.phoneUsers.length;
                if (!numberOfOptions) {
                    return;
                }
                const highlightedIndex = this.state.highlightedIndex;
                const index = highlightedIndex === 0 || highlightedIndex === null
                    ? numberOfOptions - 1
                    : highlightedIndex - 1;
                this.setState({ highlightedIndex: index });
            }
            catch (exception) { }
        }
    }
    makeCallClickHandler(user) {
        var _a;
        if (user === null) {
            return;
        }
        if ((user === null || user === void 0 ? void 0 : user.id) !== 'newUser' && this.props.selectedFromNumber) {
            this.makeCall({
                userId: user === null || user === void 0 ? void 0 : user.id,
                toNumber: user === null || user === void 0 ? void 0 : user.phone_number,
                fromNumber: (_a = this.props.selectedFromNumber) === null || _a === void 0 ? void 0 : _a.e164_format,
            });
        }
        else if (this.props.selectedFromNumber) {
            const newEndUser = {
                id: '',
                phone_number: user.phone_number.replace(/[\s()-]/g, ''),
                roles: ['enduser'],
            };
            this.props
                .userModalAddUser(newEndUser)
                .then(unwrapResult)
                .then(({ data: newUser }) => {
                var _a;
                this.makeCall({
                    userId: newUser.id,
                    toNumber: user.phone_number,
                    fromNumber: (_a = this.props.selectedFromNumber) === null || _a === void 0 ? void 0 : _a.e164_format,
                });
            })
                .catch((exception) => {
                var _a, _b;
                if (exception && exception.conflicting_id) {
                    this.makeCall({
                        userId: exception.conflicting_id,
                        toNumber: (_a = newEndUser.phone_number) !== null && _a !== void 0 ? _a : '',
                        fromNumber: (_b = this.props.selectedFromNumber) === null || _b === void 0 ? void 0 : _b.e164_format,
                    });
                }
                else {
                    Sentry.captureException(exception, {
                        level: 'error',
                        extra: {
                            note: 'userModalAddUser exception on make call',
                        },
                    });
                }
            });
        }
    }
    makeCall(payload) {
        const { userId, toNumber, fromNumber } = payload;
        if (userId && toNumber && fromNumber) {
            this.props.telephonyMakeCall({
                userId: userId,
                toNumber: toNumber,
                fromNumber: fromNumber,
            });
            this.props.setSearchUserValue('');
            this.props.resetUsers();
        }
    }
    onToggle(isOpen, isFirstOpen) {
        if (isFirstOpen) {
            this.setState({ countryDropdownOpen: true }, () => {
                this.props.countries.getItems();
            });
        }
        else if (isOpen) {
            this.setState({ countryDropdownOpen: true });
        }
        else if (!isOpen && this.props.countries.searchTerm !== '') {
            this.setState({ countryDropdownOpen: false }, () => {
                this.props.countries.searchTermChange('');
            });
        }
        else if (!isOpen) {
            this.setState({ countryDropdownOpen: false });
        }
    }
    selectCountry(country) {
        this.setState({
            countryISOSelected: country.id.toLowerCase(),
            countryCodeSelected: `${country.phone.startsWith('+') ? country.phone : `+${country.phone}`}`,
            countryDropdownOpen: false,
        }, () => {
            if (this.props.searchValue.length > 0) {
                this.props.setSearchUserValue(this.state.countryCodeSelected);
            }
            this.props.countries.searchTermChange('');
            this.focusInput();
            analytics.countryCodeSelected();
        });
    }
    onSearchCountryCode(input) {
        this.props.countries.searchTermChange(input);
    }
    showDropdown(searchValue) {
        if (this.state.loading)
            return false;
        return (searchValue === '' ||
            containsNumber(searchValue) ||
            searchValue.startsWith('+') ||
            searchValue.startsWith('-') ||
            searchValue.startsWith('('));
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const { loading } = this.state;
        let requesters;
        let helpText = _jsx("p", { children: "Type a phone number or search your contacts" });
        let disabled;
        let showSpinner = loading;
        const prefix = null;
        let tooltip = '';
        const { profile, editUser, fromNumberFormat, canMakeOutBoundCall, isOnTrial, searchValue, } = this.props;
        const listUsersProps = {
            profile,
            editUser,
            fromNumberFormat,
            canMakeOutBoundCall,
            highlightedIndex: this.state.highlightedIndex,
        };
        const verifiedNumbers = filter(this.props.dynamicTelephoneNumbersArray, {
            outgoing_functionality: true,
        });
        if (isOnTrial &&
            this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            verifiedNumbers.length === 0 &&
            this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.staticTelephoneNumbersArray.length > 0) {
            let link;
            if (((_a = this.props.profile.roles) === null || _a === void 0 ? void 0 : _a.indexOf('admin')) > -1) {
                link = (_jsx("a", Object.assign({ href: 'https://' + config.domain.web + '/demo', rel: "noopener noreferrer", target: "_blank" }, { children: "Please book a meeting with our sales team." })));
            }
            disabled = 'disabled';
            helpText = (_jsxs("p", { children: ["Your number(s) can only be used to test inbound calls. Outbound calls are not enabled while you are in trial. ", link, ' '] }));
            tooltip = 'Your number(s) can only be used to test inbound calls.';
        }
        else if (isOnTrial === false &&
            this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            verifiedNumbers.length === 0 &&
            this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.staticTelephoneNumbersArray.length > 0) {
            let link;
            if (((_b = this.props.profile.roles) === null || _b === void 0 ? void 0 : _b.indexOf('admin')) > -1) {
                link = (_jsx(Link, Object.assign({ to: "/settings/phone" }, { children: "Buy a number in settings/phone." })));
            }
            disabled = 'disabled';
            helpText = (_jsxs("p", { children: ["You do not have a verified number for outgoing calls. ", link] }));
            tooltip = `Before you can make any calls you need a number that is verified for outgoing calling. `;
        }
        else if (this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.staticTelephoneNumbersArray.length === 0 &&
            verifiedNumbers.length === 0) {
            let link;
            if (((_c = this.props.profile.roles) === null || _c === void 0 ? void 0 : _c.indexOf('admin')) > -1) {
                link = (_jsx(Link, Object.assign({ to: "/settings/phone" }, { children: "Get your free number in settings/phone." })));
            }
            disabled = 'disabled';
            helpText = (_jsxs("p", { children: ["Before you can receive calls, you need to buy a phone number. ", link] }));
            tooltip = 'Before you can receive calls, you need to buy a phone number.';
        }
        else if (this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            verifiedNumbers.length > 0 &&
            this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.staticTelephoneNumbersArray.length > 0) {
            disabled = '';
            helpText = _jsx("p", { children: "Type a phone number or search your contacts" });
        }
        else if (this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'loading' &&
            verifiedNumbers.length === 0) {
            disabled = 'disabled';
            helpText = _jsx("p", { children: "Loading..." });
            tooltip = 'Loading...';
        }
        else if (this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'loading' &&
            verifiedNumbers.length === 0) {
            disabled = 'disabled';
            helpText = _jsx("p", { children: "Loading..." });
            tooltip = 'Loading...';
        }
        else if (this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'loading' &&
            verifiedNumbers.length > 0) {
            disabled = '';
            helpText = _jsx("p", { children: "Type a phone number or search your contacts" });
        }
        else if (this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            verifiedNumbers.length === 0 &&
            this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.staticTelephoneNumbersArray.length > 0) {
            disabled = '';
            helpText = _jsx("p", { children: "No numbers found. Please widen your search." });
        }
        if (this.props.canMakeOutBoundCall === false) {
            disabled = 'disabled';
            tooltip = "Can't make outbound call";
        }
        if (this.props.meta.usersAsyncStatus === 'loading') {
            // We are fetching the users.
            requesters = _jsx("div", Object.assign({ className: styles.requestersContainer }, { children: "Loading..." }));
        }
        else if ((this.state.phoneUsers === undefined ||
            ((_d = this.state.phoneUsers) === null || _d === void 0 ? void 0 : _d.length) === 0) &&
            this.props.meta.usersAsyncStatus === 'succeeded' &&
            this.props.searchValue.length >= 2) {
            // We test that value is a valid phone number or not.
            // If valid we create a new user first and then make the call else show "no user found".
            try {
                const phoneNumber = this.props.searchValue;
                if (isNumberValid({ phoneNumber })) {
                    const user = {
                        id: 'newUser',
                        avatar_url: null,
                        icon: 'phone',
                        is_admin: false,
                        is_agent: false,
                        email: null,
                        phone_number: phoneNumber.replace(/[^+0-9]/gi, ''),
                        name: '',
                        roles: [],
                    };
                    requesters = [user].map((user, index) => (_jsx(ListUsers, Object.assign({ user: user, index: index }, listUsersProps, { makeCallClickHandler: this.makeCallClickHandler, userType: "new" }), user.id)));
                }
                else {
                    requesters = (_jsx("div", Object.assign({ className: styles.requestersContainer }, { children: "Sorry, contact not found" })));
                }
            }
            catch (exception) {
                requesters = (_jsx("div", Object.assign({ className: styles.requestersContainer }, { children: "Sorry, contact not found" })));
            }
        }
        else if (this.props.meta.usersAsyncStatus === 'failed') {
            requesters = (_jsx("div", Object.assign({ className: styles.requestersContainer }, { children: "Error while fetching user" })));
        }
        else if (((_e = this.state.phoneUsers) === null || _e === void 0 ? void 0 : _e.length) > 0) {
            requesters = this.state.phoneUsers.map((user, index) => (_jsx(ListUsers
            // Duplicates has same ids, add index to prevent duplicate keys
            , Object.assign({ index: index, user: user }, listUsersProps, { makeCallClickHandler: this.makeCallClickHandler, userType: user.duplicate ? 'additional_phone_duplicate' : 'regular' }), user.id + user.duplicate ? index : '')));
        }
        else if (this.props.meta.usersAsyncStatus === 'succeeded' &&
            this.props.searchValue.length === 0) {
            requesters = null;
        }
        else if (this.props.searchValue.length > 0) {
            requesters = null;
        }
        if (this.props.telephonyMeta.makeCall === 'loading' ||
            this.props.telephonyMeta.internalCall === 'loading' ||
            this.props.telephonyMeta.makeCallback === 'loading') {
            showSpinner = true;
            disabled = 'disabled';
            tooltip = 'Calling...';
        }
        const countryDropdown = (_f = this.props.countries) === null || _f === void 0 ? void 0 : _f.items.map((country) => ({
            id: country.iso,
            phone: country.phone,
            name: _jsx(CountryCodeDropdownItem, { country: country }),
        }));
        return (_jsxs("ul", { children: [_jsxs("li", Object.assign({ className: "search-users-to-call" }, { children: [helpText, _jsx(Tooltip, Object.assign({ content: tooltip, dark: true, disabled: !tooltip }, { children: _jsxs("div", Object.assign({ className: styles.phoneInput }, { children: [prefix, _jsx(InputText, Object.assign({ placeholder: "Enter number or name", disabled: disabled, name: "searchUser", value: this.props.searchValue
                                            .split(this.state.countryCodeSelected)
                                            .pop(), onChange: this.onChangeInput, onKeyDown: this.searchInputKeyDown, ref: this.input }, (this.showDropdown(searchValue)
                                        ? {
                                            prefix: {
                                                type: 'custom',
                                                noWrap: true,
                                                value: (_jsx(FieldAddonDropdown, { meta: {
                                                        selectedValue: (_jsx(CountryCodeSelected, { countryISOSelected: this.state.countryISOSelected, countryCodeSelected: this.state.countryCodeSelected })),
                                                    }, hasSearch: true, searchPlaceholder: "Search for country", items: countryDropdown, onToggle: this.onToggle, onSelect: this.selectCountry, onSearch: this.onSearchCountryCode, dropdownProps: {
                                                        style: { width: '300px', left: 0 },
                                                        onClick: (e) => {
                                                            e.stopPropagation();
                                                        },
                                                    } })),
                                            },
                                        }
                                        : undefined), (showSpinner
                                        ? {
                                            prefix: {
                                                type: 'custom',
                                                value: _jsx(Spinner, { size: 18 }),
                                            },
                                        }
                                        : undefined)))] })) }))] })), requesters] }));
    }
}
__decorate([
    boundMethod
], SearchUser.prototype, "updateUserCountryCodeDetails", null);
__decorate([
    boundMethod
], SearchUser.prototype, "focusInput", null);
__decorate([
    boundMethod
], SearchUser.prototype, "setSearchValue", null);
__decorate([
    boundMethod
], SearchUser.prototype, "handlePhoneNumberInput", null);
__decorate([
    boundMethod
], SearchUser.prototype, "handleCopyPastePhoneNumber", null);
__decorate([
    boundMethod
], SearchUser.prototype, "onChangeInput", null);
__decorate([
    boundMethod
], SearchUser.prototype, "_requestGetUsers", null);
__decorate([
    boundMethod
], SearchUser.prototype, "searchInputKeyDown", null);
__decorate([
    boundMethod
], SearchUser.prototype, "makeCallClickHandler", null);
__decorate([
    boundMethod
], SearchUser.prototype, "makeCall", null);
__decorate([
    boundMethod
], SearchUser.prototype, "onToggle", null);
__decorate([
    boundMethod
], SearchUser.prototype, "selectCountry", null);
__decorate([
    boundMethod
], SearchUser.prototype, "onSearchCountryCode", null);
__decorate([
    boundMethod
], SearchUser.prototype, "showDropdown", null);
